import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import Modal from '@deprecated-ui/common/Modal';
import color from '@deprecated-ui/_style/color';
import ReactHtmlParser from 'html-react-parser';
import Image from 'global/Image';
import If from 'global/ErrorHandlers/If';
import { ORDER_TYPE } from 'constants/trading';
import tradingDataStore from 'lib/stores/tradingData';
import tradingModalStore from 'global/TradingModal/store';

interface AnnouncementProps {
  visible: boolean;
  orderType: string;
  closeModal: () => void;
  onSubmit: () => void;
  showTransactionModal: () => void;
}

function AnnouncementModal({
  visible,
  orderType,
  closeModal,
  onSubmit,
  showTransactionModal,
}: AnnouncementProps) {
  const isExerciseType = orderType === ORDER_TYPE.EXERCISE;

  const {
    rightTradeable: { data: rightData },
    exercise: { data: exerciseData },
  } = tradingDataStore();
  const { showModal } = tradingModalStore();

  let is_tradeable = rightData?.is_tradeable;
  let not_tradeable_type;
  let not_tradeable_reason = rightData?.message;
  let end_date_exercise;
  let is_exerciseable = true;
  let not_exerciseable_type;
  let not_exerciseable_reason;

  const differentTradeable =
    rightData?.is_tradeable && exerciseData && !exerciseData.is_tradeable;

  if (!rightData || differentTradeable) {
    is_tradeable = exerciseData?.is_tradeable;
    not_tradeable_type = exerciseData?.not_tradeable_type;
    not_tradeable_reason = exerciseData?.not_tradeable_reason;
  }

  if (exerciseData) {
    is_exerciseable = exerciseData?.is_exerciseable;
    not_exerciseable_reason = exerciseData?.not_exerciseable_reason;
    end_date_exercise = exerciseData?.end_date_exercise;
    not_exerciseable_type = exerciseData?.not_exerciseable_type;
    if (!is_tradeable && !not_tradeable_type) {
      not_tradeable_type = exerciseData?.not_tradeable_type;
    }
  }

  const showDates = ['MAX_EXERCISE_AT', 'SELL_RECOMMEND'];
  const announcementType = isExerciseType
    ? not_exerciseable_type
    : not_tradeable_type;
  const isOutOfSession = announcementType === 'OUT_OF_SESSION';
  const messageReasonToRender = isExerciseType
    ? not_exerciseable_reason
    : not_tradeable_reason;

  const handleClick = () => {
    if (announcementType === 'SELL_RECOMMEND') {
      showModal({ orderType: ORDER_TYPE.SELL });
      showTransactionModal();
      return;
    }

    const isExercisable = isExerciseType && is_exerciseable;
    const notExerciseTradeable = !isExerciseType && is_tradeable;
    const notExerciseRightTradable =
      !isExerciseType && rightData?.is_tradeable && !isOutOfSession;

    if (isExercisable || notExerciseTradeable || notExerciseRightTradable) {
      showTransactionModal();
      return;
    }
    if (onSubmit) onSubmit();
    else closeModal();
  };

  const broadcast = '/images/broadcast.svg';
  const not_found = '/images/data_not_found.svg';

  const icon = {
    DEFAULT: broadcast,
    OUT_OF_SESSION: not_found,
  };

  const titles = {
    OUT_OF_SESSION: 'Transaksi Tidak Dapat Dilakukan',
    DEFAULT: 'Perhatian',
  };

  const buttons = {
    EXPIRED: 'Lanjut',
    MAX_EXERCISE_AT: isExerciseType ? 'Oke, Mengerti' : 'Lanjut',
    SELL_RECOMMEND: 'Sell',
    DEFAULT: 'Oke, Mengerti',
  };

  const buttonTypes = {
    SELL_RECOMMEND: 'danger',
    DEFAULT: 'primary',
  };

  return (
    <Modal visible={visible} closable={false} centered width="375px">
      <Flex direction="column" align="center" padding="30px">
        <Image
          src={icon[announcementType] || icon.DEFAULT}
          alt="Announcement"
        />
        {/* @ts-expect-error */}
        <Text align="center" family="bold" size="16px" my="16px">
          {titles[announcementType] || titles.DEFAULT}
        </Text>
        <Text align="center" color={color.dimgray}>
          {ReactHtmlParser(messageReasonToRender || '-')}
        </Text>
        <If
          condition={showDates.includes(announcementType) && end_date_exercise}
        >
          {/* @ts-expect-error */}
          <Text color="#f5931b" family="bold" pt="15px">
            {end_date_exercise}
          </Text>
        </If>
      </Flex>

      <Flex
        justify="space-between"
        style={{ position: 'absolute', bottom: '-50px', width: '100%' }}
      >
        <Button
          type={buttonTypes[announcementType] || buttonTypes.DEFAULT}
          radius="4px"
          block
          height="40px"
          onClick={handleClick}
        >
          <Text align="inherit" color="white" family="bold" size="16px">
            {buttons[announcementType] || buttons.DEFAULT}
          </Text>
        </Button>
      </Flex>
    </Modal>
  );
}

export default AnnouncementModal;
